// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Your entries`
};

const de_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Deine Einträge`
};

const es_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Tus entradas`
};

const fr_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Vos chances de gagner`
};

const fi_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Sinun arpasi`
};

const hi_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `आपकी एंट्रीज़`
};

const ja_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `あなたのエントリー`
};

const nl_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Je deelnames`
};

const pt_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Suas participações`
};

const ro_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Participările tale`
};

const th_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `รายการของคุณ`
};

const ur_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `آپ کی شمولیت`
};

const zh_hant1_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `您的抽獎機會`
};

const da_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Dine deltagelser`
};

const it_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Le tue partecipazioni`
};

const vn_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Lượt tham gia của bạn`
};

const ko_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `내 참여 횟수`
};

const tr_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Katılımlarınız`
};

const lv_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Jūsu ieraksti`
};

const ar_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `مشاركاتك`
};

const bs_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Vaša učešća`
};

const sl_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Vaši vnosi`
};

const id_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Entri Anda`
};

const sv_widget_stats_your_entries = /** @type {(inputs: {}) => string} */ () => {
	return `Dina deltaganden`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_stats_your_entries = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_stats_your_entries(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_stats_your_entries", locale)
	if (locale === "en") return en_widget_stats_your_entries(inputs)
	if (locale === "de") return de_widget_stats_your_entries(inputs)
	if (locale === "es") return es_widget_stats_your_entries(inputs)
	if (locale === "fr") return fr_widget_stats_your_entries(inputs)
	if (locale === "fi") return fi_widget_stats_your_entries(inputs)
	if (locale === "hi") return hi_widget_stats_your_entries(inputs)
	if (locale === "ja") return ja_widget_stats_your_entries(inputs)
	if (locale === "nl") return nl_widget_stats_your_entries(inputs)
	if (locale === "pt") return pt_widget_stats_your_entries(inputs)
	if (locale === "ro") return ro_widget_stats_your_entries(inputs)
	if (locale === "th") return th_widget_stats_your_entries(inputs)
	if (locale === "ur") return ur_widget_stats_your_entries(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_stats_your_entries(inputs)
	if (locale === "da") return da_widget_stats_your_entries(inputs)
	if (locale === "it") return it_widget_stats_your_entries(inputs)
	if (locale === "vn") return vn_widget_stats_your_entries(inputs)
	if (locale === "ko") return ko_widget_stats_your_entries(inputs)
	if (locale === "tr") return tr_widget_stats_your_entries(inputs)
	if (locale === "lv") return lv_widget_stats_your_entries(inputs)
	if (locale === "ar") return ar_widget_stats_your_entries(inputs)
	if (locale === "bs") return bs_widget_stats_your_entries(inputs)
	if (locale === "sl") return sl_widget_stats_your_entries(inputs)
	if (locale === "id") return id_widget_stats_your_entries(inputs)
	if (locale === "sv") return sv_widget_stats_your_entries(inputs)
	return "widget_stats_your_entries"
};